const FboCompanyNames = {
  Amazon: 'Amazon',
  Fulfill99: 'Fulfill99',
  Melonn: 'Melonn',
};

export default FboCompanyNames;
